import React from "react";
import { useSupplierOrderStore } from "../../../../store/useSupplierOrderStore.ts";

const SupplierRenderReviewButton = ({
      review,
      entityType,
      shipmentId,
      shipmentItemId,
      orderId,
      info
    }) => {
  const openViewReview = useSupplierOrderStore((s) => s.openViewReview);

  if (!review?.has_review) return null;

  const handleClick = () => {
    openViewReview(
      {
        entityType,
        shipmentId,
        shipmentItemId,
        orderId,
        info
      },
      review
    );
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="px-3 py-1 text-xs bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
    >
      مشاهده نظر
    </button>
  );
};

export default SupplierRenderReviewButton;
